// User-defined attributes: the quiet notice a screen shows when it could not
// work out which additional details apply. The record stays fully usable —
// the server decides applicability again at save (plan D6) — so this is a
// line of text with a retry, never a modal or a blank screen.

import { RotateCcw } from 'lucide-react'

export function UdaNotice({ message, onRetry }: { message: string; onRetry?: () => void }) {
  return (
    <div role="status" data-tw-msg="warning" style={{
      display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap',
      margin: '8px 24px 0', padding: '8px 12px', borderRadius: 8, fontSize: 13,
      background: 'var(--color-warning-weak)', color: 'var(--color-text)',
    }}>
      <span style={{ flex: 1, minWidth: 0 }}>
        The additional details could not be loaded ({message}). You can keep working; they are checked
        again when you save.
      </span>
      {onRetry && (
        <button type="button" onClick={onRetry} style={{
          display: 'inline-flex', alignItems: 'center', gap: 5, border: 0, background: 'transparent',
          color: 'var(--color-accent)', cursor: 'pointer', fontSize: 13, fontFamily: 'inherit', padding: 2,
        }}><RotateCcw size={13} />Try again</button>
      )}
    </div>
  )
}
